import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import {
  auditLogSchema,
  auditLogListResponseSchema,
  auditLogFiltersSchema,
  rbacPermissionSchema,
  exportAuditLogSchema,
} from '../schemas/audit.schemas';
import { errorResponseSchema, paginationQuerySchema } from '../schemas/common.schemas';

const c = initContract();

export const auditContract = c.router({
  listAuditLogs: {
    method: 'GET',
    path: '/audit/logs',
    query: paginationQuerySchema.merge(auditLogFiltersSchema),
    responses: {
      200: auditLogListResponseSchema,
      400: errorResponseSchema,
      401: errorResponseSchema,
    },
    summary: 'List audit logs with XAI trail',
  },
  getAuditLog: {
    method: 'GET',
    path: '/audit/logs/:id',
    pathParams: z.object({
      id: z.string().uuid(),
    }),
    responses: {
      200: auditLogSchema,
      404: errorResponseSchema,
      401: errorResponseSchema,
    },
    summary: 'Get detailed audit log entry',
  },
  checkPermission: {
    method: 'POST',
    path: '/audit/rbac/check',
    body: z.object({
      resource: z.string(),
      action: z.string(),
    }),
    responses: {
      200: rbacPermissionSchema,
      400: errorResponseSchema,
      401: errorResponseSchema,
    },
    summary: 'Check RBAC permission for current user',
  },
  exportAuditLog: {
    method: 'POST',
    path: '/audit/logs/export',
    body: exportAuditLogSchema,
    responses: {
      200: z.object({
        downloadUrl: z.string(),
        expiresAt: z.coerce.date(),
      }),
      400: errorResponseSchema,
      401: errorResponseSchema,
    },
    summary: 'Export audit logs to JSON or CSV',
  },
});
